module.exports = __webpack_public_path__ + "static/media/materiały_do_social_media_420x240px.da9f7969.png";